export default "__VITE_ASSET__ce998557__"